export default __webpack_public_path__ + "aeffd8025cba3647f1a6c07f222d985e.woff";